export default {
	'site-menu': () => import('./components/site-menu.js'),
	video: () => import('./components/video.js'),
	testimonials: () => import('./components/testimonials.js'),
	faq: () => import('./components/faq.js'),
	'form-engine': () => import('./components/form-engine.js'),
	'articles-list': () => import('./pages/articles-list.js'),
	'articles-related': () => import('./pages/articles-related.js'),
	'home-marquee': () => import('./pages/home-marquee.js'),
	'home-terraces': () => import('./pages/home-terraces.js'),
	'home-map': () => import('./pages/home-map.js'),
	'places-search': () => import('./components/places-search.js'),
	'map-filters': () => import('./components/map-filters.js'),
	'map-page': () => import('./pages/map-page.js'),
	'espace-auth': () => import('./components/espace-auth.js'),
	'form-collecte': () => import('./components/form-collecte.js'),
};
